import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ed48272e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ed48272e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed48272e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed48272e')) {
      api.createRecord('ed48272e', component.options)
    } else {
      api.reload('ed48272e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ed48272e&scoped=true", function () {
      api.rerender('ed48272e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mp/wx-auto-reply/index.vue"
export default component.exports